export default "__VITE_ASSET__DD6Zy3Kx__"